import React from 'react';

const AccessibilityIconBrightness = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="5" fill="white" />
    <g clip-path="url(#clip0_9242_79847)">
      <path
        d="M5.21875 12C5.21875 15.7452 8.25481 18.7812 12 18.7812C15.7452 18.7812 18.7812 15.7452 18.7812 12C18.7812 8.25484 15.7452 5.21875 12 5.21875C8.25484 5.21875 5.21875 8.25481 5.21875 12ZM12 17.0312V6.96875C14.781 6.96875 17.0312 9.21944 17.0312 12C17.0312 14.781 14.7806 17.0312 12 17.0312Z"
        fill="current"
      />
    </g>
    <defs>
      <clipPath id="clip0_9242_79847">
        <rect width="14" height="14" fill="white" transform="translate(5 5)" />
      </clipPath>
    </defs>
  </svg>
);

export default AccessibilityIconBrightness;
